'use client'

import { notFound } from 'next/navigation'
import { renderCustomAddToCartFlow } from '../flowComponents'

type AddToCartFlowClientProps = {
  flowSlug: string
  searchParams: Record<string, string | string[] | undefined>
}

export function AddToCartFlowClient({
  flowSlug,
  searchParams,
}: AddToCartFlowClientProps) {
  const node = renderCustomAddToCartFlow({ flowSlug, searchParams })
  if (node == null) notFound()
  return node
}
